import { REVIEWS, IMAGES } from "@/data/site";
import { usePageMeta, PageHero, SectionLabel, StarRating, CTABanner } from "@/components/common";
import { Quote } from "lucide-react";

export default function Reviews() {
  usePageMeta("Customer Reviews", "Read verified 5-star reviews for A.D.N Stucco Inc from homeowners and businesses across Central Florida.");
  return (
    <div data-testid="reviews-page">
      <PageHero label="Customer Reviews" title="What our clients say" subtitle="We're proud of the relationships we build. Here's what Central Florida homeowners and businesses say about working with us." image={IMAGES.craftsman} />

      <section className="py-16 bg-adn-charcoal text-white">
        <div className="max-w-5xl mx-auto px-6 grid grid-cols-2 sm:grid-cols-4 gap-8 text-center">
          {[["5.0", "Average Rating"], ["1k+", "Happy Customers"], ["100%", "Satisfaction"], ["25+", "Years Trusted"]].map(([n, l]) => (
            <div key={l}>
              <div className="text-4xl font-heading font-black text-adn-red">{n}</div>
              <div className="label-accent text-zinc-400 mt-2">{l}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-24 bg-adn-white">
        <div className="max-w-7xl mx-auto px-6">
          <SectionLabel>Testimonials</SectionLabel>
          <h2 className="text-4xl font-heading font-extrabold mt-6 mb-14">Reviews from real customers</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {REVIEWS.map((r) => (
              <div key={r.name} data-testid={`review-card-${r.name}`} className="relative bg-adn-off p-8 border border-zinc-200">
                <Quote size={40} className="text-adn-red/20 absolute top-6 right-6" />
                <StarRating />
                <p className="text-zinc-700 mt-5 leading-relaxed italic">"{r.text}"</p>
                <div className="mt-6 pt-6 border-t border-zinc-200">
                  <div className="font-heading font-bold">{r.name}</div>
                  <div className="text-sm text-adn-red font-semibold">{r.city}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CTABanner title="Ready to Join Our Happy Customers?" />
    </div>
  );
}
